'use strict';

import {SET_REPRICING_AMOUNT} from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';

const trackingUtils = require('../../modules/utils/tracking.utils');
const passengersUtils = require('../../modules/utils/passengers.utils.js');
const priceSubscriberMixin = require('../../modules/mixins/price_subscriber.mixin');
const trackingPageFlowMixin = require('../../modules/mixins/tracking.page.flow.mixin');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');
const {trackJQElementDisplayed, trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const logger = require('od-modules/utils/logger');
const isDynpack = Odigeo.Utils.isRequestApp('dp');

Odigeo.defineWidget('repricing_popup_manager', Odigeo.Widget.extend(trackingPageFlowMixin.extend({
    concepts: {
        'REPRICING': 'r',
        'ADULTS': 'pa',
        'CHILDREN': 'pc',
        'INFANTS': 'pi',
        'SERVICE_FEE': 'fs',
        'CC_FEE': 'fc',
        'INSURANCE': 'i',
        'BAGGAGES': 'b',
        'BAGGAGES_WEIGHT': 'bw',
        'PROMO_CODE': 'cp',
        'SERVICE_OPTIONS': 'so',
        'DISCOUNT_FEE': 'fd',
        'SEAT': 's',
        'HOTEL': 'h',
        'MEMBERSHIP_SUBSCRIPTION': 'ms',
    },
    trackingPageFlowAppearancesSettings: {
        flow: 'payment_flow_appearances',
        label: 'reprice:ap',
    },
    flowTracked: false,
    modelClass: Odigeo.Model.extend(priceSubscriberMixin.extend({
        init: function() {
            this.bindPriceSubscribers();
        },
        bindPriceSubscribers: function() {
            this.bindPriceCollection();
        },
        getRepricingValues: function() {
            return {
                newPrice: Odigeo.Utils.splitFormatedCurrency(this.get('repricing').newPrice),
                oldPrice: Odigeo.Utils.splitFormatedCurrency(this.get('repricing').oldPrice),
                template: this.widget.options.isRepricingTendency ? 'prismaPopup' : 'popup',
            };
        },
    })),
    viewClass: Odigeo.View.extend({
        events: {
            'tap @acceptRepricing': 'onAcceptRepricing',
            'tap @lowAcceptanceRepricingButton': 'onLowAcceptanceRepricingButton',
            'tap @closePopup': 'onClosePopupClick',
        },

        selectors: {
            popup: '.repricing_popup',
            acceptRepricing: '.confirm_repricing',
            closePopup: '.cancel_repricing',
            lowAcceptanceRepricingButton: '.low_acceptance_repricing_button',
            contentLayer: '.content_layer',
        },

        init: function() {
            this.trackRepricingDisplayed = Odigeo._.once(trackJQElementDisplayed);
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.isRepricingTendency = this.widget.options.isMobile && this.widget.options.isRepricingTendency;
            this.listenTo(this.model, 'change:show', Odigeo._.bind(this.renderPopup, this));
            this.listenTo(this.model, 'priceCollection.repaintPrices', this.refreshPrices);
        },

        refreshPrices: function() {
            if (this.model.get('show')) {
                this.renderPopup();
            }
        },

        closePopUp: function(label) {
            trackingUtils.trackEvent('repricing_popup', 'repricing_appearances_' + label, 'payment');
            this.removePopup();
        },

        onAcceptRepricing: function(event) {
            this.closePopUp(this.getRepricingTrackingLabel());
            trackClickEvent(event);
            Odigeo.trigger(this.widget.id + ':confirmRepricing');
        },

        onLowAcceptanceRepricingButton: function() {
            Odigeo.Router.navigate(isDynpack ? 'dpresults_flights' : 'results', {
                params: Odigeo.History.getFragment().split('/')?.[1],
            });
            trackingUtils.trackEvent('repricing_popup', 'repricing_error-msg_back-results');
        },

        onClosePopupClick: function(event) {
            trackClickEvent(event);
            Odigeo.Session.set('repricingClose', 'repricing_closed_purchase_' + this.getRepricingTrackingLabel());
            this.closePopUp('close');
        },

        getRepricingTrackingLabel: function() {
            const templateLabel = 'default';
            var oldPrice = this.model.get('repricing').oldPrice;
            var newPrice = this.model.get('repricing').newPrice;
            return 'iprice:' + oldPrice + '_fprice:' + newPrice + '_pax:' + passengersUtils.getNumberOfPassengers() + '_msg:' + templateLabel;
        },

        removePopup: function() {
            this.animateLayer(false);
            setTimeout(() => {
                this.$cachedSelectors.popup.remove();
                this.model.set('show', false);
            }, this.isRepricingTendency ? 350 : 0);
        },

        animateLayer(show) {
            if (this.isRepricingTendency) {
                const $layer = this.$el.find(this.selectors.contentLayer);
                const height = show ? $layer.height() - 2 : 0;
                const cssTransform = `translateY(-${height}px)`;
                $layer.css({
                    'transform': cssTransform,
                    '-o-transform': cssTransform,
                    '-webkit-transform': cssTransform,
                });
            }
        },

        renderPopup: function(newPriceMobile) {
            if (this.model.get('show')) {
                const priceDiff = this.model.get('repricing').newPrice - this.model.get('repricing').oldPrice;
                Odigeo.trigger(this.widget.id + ':stopPSD2Waiting');
                this.trackRepricingDisplayed(this.$el);
                let repricing = this.model.getRepricingValues(newPriceMobile);
                dispatch({type: SET_REPRICING_AMOUNT, entry: repricing.newPrice.quantity});
                this.setTemplate(this.$el, repricing.template, Odigeo._.extend(this.widget.options, {
                    newPrice: repricing.newPrice,
                    oldPrice: repricing.oldPrice,
                    isSelectedFlightChangeableForFree: this.isFreeRebooking(),
                }));
                logger.message(`repricingPriceDiff: ${priceDiff}; bookingId ${Odigeo.Session.get('bookingId')}`);
                this.animateLayer(true);
                this.manageFlowTracking();
            }
        },

        isFreeRebooking() {
            return (
                (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isPrimeDays) &&
                flightChangeFreeUtil.isSelectedFlightChangeableForFree()
            );
        },

        trackPersuassiveMsg() {
            let label = this.widget.options.freeCancellationHoursApart > 0 ? 'repricing_free_cancellation_message' : null;
            label = this.widget.options.isRepricingTendency && this.isFreeRebooking() ? 'repricing_free_rebooking_message' : label;
            if (label) {
                trackingUtils.trackEvent('repricing_popup', label);
            }
        },

        manageFlowTracking() {
            if (!this.widget.flowTracked) {
                this.widget.flowTracked = true;
                this.widget.registerTrackingPageFlow();
                this.widget.launchAppearancesTracking();
                setTimeout(() => {
                    this.trackPersuassiveMsg();
                }, 1000);
            }
        },
    }),
    setRepricing: function(repricing) {
        var args = [].slice.call(arguments, 0);
        if (!this.model.get('show')) {
            this.model.set({repricing: args[0], show: true});
            trackingUtils.trackEvent('back_end_errors',
                `repricing_appearances_${this.view.getRepricingTrackingLabel(repricing.oldPrice, repricing.newPrice)}`);
        }
    },
    setNewPrice: function(newPrice) {
        if (this.model.get('show') && !Odigeo._.isUndefined(newPrice)) {
            this.view.renderPopup(newPrice);
        }
    },
})));
